import { render, staticRenderFns } from "./AVSOffer.vue?vue&type=template&id=283f817b&"
import script from "./AVSOffer.vue?vue&type=script&lang=js&"
export * from "./AVSOffer.vue?vue&type=script&lang=js&"
import style0 from "./AVSOffer.vue?vue&type=style&index=0&id=283f817b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports